import React, { memo, ReactElement } from 'react'
import { $enum } from 'ts-enum-util'
import { LOAD_STATE } from 'apps/fleet-planner/constants/loads'
import { IStop } from 'apps/fleet-planner/types'
import {
  getLoadStatusTagLabel,
  getLoadStatusTagStyle,
  filterStopsByType,
} from 'apps/fleet-planner/utils/loadStatusTags'
import { TAG_SIZE, Tag } from 'transfix-ui'

export interface ILoadStatusTagProps {
  status: LOAD_STATE
  size?: TAG_SIZE
  stops: IStop[]
  currentStopSequence?: number
}

export const LoadStatusTag = memo<ILoadStatusTagProps>(
  ({ status, size = TAG_SIZE.small, stops = [], currentStopSequence = 0 }): ReactElement => {
    const { currentStopIndex, currentStopType, stopsOfCurrentStopType } = filterStopsByType({
      stops,
      currentStopSequence,
    })
    const statusKey = $enum(LOAD_STATE).getKeyOrDefault(status, 'Pending')
    const statusTagLabel = getLoadStatusTagLabel(
      statusKey,
      currentStopType,
      currentStopIndex,
      stopsOfCurrentStopType.length
    )
    const statusTagStyle = getLoadStatusTagStyle(statusKey)
    return (
      <Tag
        label={statusTagLabel}
        size={size}
        tagStyle={statusTagStyle}
        outlineOnly={status === LOAD_STATE.Pending}
      />
    )
  }
)
